@if (feedbackPopupVisible == true) {
  <app-feedbackpopup [userId]="userId" [email]="userEmail" [organizationKey]="organizationKey" [projectKey]="projectKey"></app-feedbackpopup>
}

@if (isAnonymous == false && loggedOut == false && isHeaderVisible == true && userOrganizations.length > 0) {
  <nav class="navbar navbar-expand-lg mx-1 ">
    <div style="display: flex; align-items: center;">
      <a  href="https://wroolo.com/feed/{{organizationKey}}/{{projectKey}}" >
        <img src="../../assets/logo-header.png" width="40" class="mb-1 mx-1">
      </a>
      <div class="grey-left-frame mx-3"></div>
      <div>
        <a  href="https://wroolo.com/feed/{{organizationKey}}/{{projectKey}}" class="system-name">
          Wroolo
        </a>
      </div>
    </div>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      @if (userOrganizations.length == 1 && organizationKey != '') {
        <div class="mx-1 mt-2">
          {{userOrganizations[0].name}}
        </div>
      }
      @if (userOrganizations.length > 1 && organizationKey != '') {
        <div class="mx-1 mt-2">
          <select id="changeorg" class="form-select-sm grey-dropdown" [(ngModel)]="organizationKey" (change)="changeOrganization($event)">
            @for (org of userOrganizations; track org) {
              <option  [value]="org.key">{{org.name}}</option>
            }
          </select>
        </div>
      }
      @if (isProjectVisible == true && userProjects != undefined && userProjects.length == 1) {
        <div class="mx-1 mt-2">
          / {{userProjects[0].name}}
        </div>
      }
      @if (isProjectVisible == true && userProjects != undefined && userProjects.length > 1) {
        <div class="mx-1 mt-2">
          <select id="changeprj" class="form-select-sm grey-dropdown" [(ngModel)]="projectKey" (change)="changeProject($event)">
            @for (prj of userProjects; track prj) {
              <option  [value]="prj.key">{{prj.name}}</option>
            }
          </select>
        </div>
      }
      <div class="grey-left-frame mx-3"></div>
      @if (isSearchVisible == true && organizationKey != undefined && projectKey != undefined) {
        <form class="mx-1 p-0 me-auto mt-2" role="search" (submit)="search(searchQuery, false)">
          <div class="input-group p-0 form-group-sm">
            <input id="searchinput" class="form-control p-0 m-0 form-control-sm input-sm grey-dropdown" style="width: 250px;" type="search" placeholder="search with AI" aria-label="Search" [(ngModel)]="searchQuery" name="searchQuery" (keydown.enter)="search(searchQuery, false)">
            <button class="btn btn-secondary btn-sm" type="submit">
              <span class="mdi--search"></span>
            </button>
            @if (selectedContentKeys.length > 0) {
              <button class="btn btn-secondary btn-sm yellow-button" type="button" (click)="ask(searchQuery)" data-bs-toggle="tooltip" data-bs-placement="top" title="Chat with selected content" data-bs-delay="{show: 1000}">
                <span class="hugeicons--chat-bot"></span>
              </button>
            } @else {
              <button class="btn btn-secondary btn-sm" type="button" (click)="ask(searchQuery)" data-bs-toggle="tooltip" data-bs-placement="top" title="Chat with your entire knowledge base" data-bs-delay="{show: 1000}">
                <span class="hugeicons--chat-bot"></span>
              </button>
            }
          </div>
        </form>
      }
      <div class="grey-left-frame mx-3"></div>
      @if (isReadOnly == true) {
        <i class="bi bi-lock mt-2" data-bs-toggle="tooltip" data-bs-placement="top" title="You are in read-only mode in this project. If you wish to edit content, ask the administrator to grant you permission." data-bs-delay="{show: 1000}"></i>
      }
      <li class="mx-1 mt-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Settings menu" data-bs-delay="{show: 500}">
        <div class="dropdown dropdown-menu-start">
          @if (userPhotoURL != undefined && userPhotoURL != '') {
            <img src="{{userPhotoURL}}" class="user-picture btn btn-outline-secondary btn-sm dropdown-toggle noborder" type="button" data-bs-toggle="dropdown" >
          }
          @if (userPhotoURL == undefined || userPhotoURL == '') {
            <button type="button" data-bs-toggle="dropdown" class="btn btn-outline-secondary btn-sm dropdown-toggle noborder">
              <i class="bi bi-list"></i>
            </button>
          }
          <ul class="dropdown dropdown-menu no-break">
            <li>
              <a type="button" (click)="navigateTo('userprofile', organizationKey)" class="btn btn-outline-secondary btn-sm noborder" href="javascript:void(0);">
                <i class="bi bi-person"></i>
                User profile
              </a>
            </li>
            @if (organizationKey != '' && isReadOnly == false) {
              <li>
                <a type="button" (click)="addUserToProject()" class="btn btn-outline-secondary btn-sm noborder" href="javascript:void(0);">
                  <i class="bi bi-person-add"></i>
                  Add user to project
                </a>
              </li>
            }
            @if (organizationKey != '') {
              <li>
                <a type="button" (click)="copyTextToClipboard(organizationKey+'/'+projectKey)" class="btn btn-outline-secondary btn-sm noborder" href="javascript:void(0);">
                  <i class="bi bi-share"></i>
                  Copy project link to clipboard
                </a>
              </li>
              <li>
                <a type="button" (click)="navigateToReport()" class="btn btn-outline-secondary btn-sm noborder" href="javascript:void(0);">
                  <i class="bi bi-bar-chart-line"></i>
                  See project reports
                </a>
              </li>
            }
            <li>
              <a type="button" href="https://discord.gg/ZSCxx6qTeU" class="btn btn-outline-secondary btn-sm noborder">
                <i class="bi bi-discord"></i>
                Wroolo Discord channel
              </a>
            </li>
            <li>
              <a type="button" class="btn btn-outline-secondary btn-sm noborder" (click)="logOut()" href="javascript:void(0);">
                <i class="bi bi-box-arrow-right"></i>
                Log out
              </a>
            </li>
            <li>
              <a type="button" class="btn btn-outline-secondary btn-sm noborder" (click)="navigateToValidator()" href="javascript:void(0);">
                Document Validator
              </a>
            </li>
            <li>
              <a type="button" class="btn btn-outline-secondary btn-sm noborder" (click)="navigateTo('agent', organizationKey)" href="javascript:void(0);">
                Stock agent
              </a>
            </li>
            <li>
              <a type="button" class="btn btn-outline-secondary btn-sm noborder" (click)="navigateTo('companyreports', organizationKey)" href="javascript:void(0);">
                Company reports
              </a>
            </li>
            <!--li>
            <a type="button" class="btn btn-outline-secondary btn-sm noborder" (click)="reindexAllContent()" href="javascript:void(0);">
              Reindex all content
            </a>
          </li-->
        </ul>
      </div>
      </li>
    @if (isChatVisible == false && isProjectVisible == true && organizationKey != '') {
      <li class="mx-1 mt-1" data-bs-toggle="tooltip" data-bs-placement="top" title="Show discussion panel" data-bs-delay="{show: 500}">
        <a (click)="showChat()" type="button" class="btn btn-outline-secondary btn-sm noborder mt-1" >
          <i class="bi bi-chat-left-text"></i>
        </a>
      </li>
    }
    @if (isChatVisible == true && isProjectVisible == true) {
      <li class="mx-1 mt-1">
        <a (click)="hideChat()" type="button" class="btn btn-outline-secondary btn-sm noborder mt-1" >
          <i class="bi bi-chat-left-text"></i>
        </a>
      </li>
    }
</ul>
</div>
  </nav>
}


